import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { StructurePage } from './pages/StructurePage';
import { ImpactPage } from './pages/ImpactPage';
import { StoriesPage } from './pages/StoriesPage';
import { GetInvolvedPage } from './pages/GetInvolvedPage';
import { DonatePage } from './pages/DonatePage';
import { BlogPage } from './pages/BlogPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <ScrollToTop data-id="element-3" />
      <Routes data-id="element-4">
        <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
        <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
        <Route path="/programs" element={<ProgramsPage data-id="element-10" />} data-id="element-9" />
        <Route path="/structure" element={<StructurePage data-id="element-12" />} data-id="element-11" />
        <Route path="/impact" element={<ImpactPage data-id="element-14" />} data-id="element-13" />
        <Route path="/stories" element={<StoriesPage data-id="element-16" />} data-id="element-15" />
        <Route path="/get-involved" element={<GetInvolvedPage data-id="element-18" />} data-id="element-17" />
        <Route path="/donate" element={<DonatePage data-id="element-20" />} data-id="element-19" />
        <Route path="/blog" element={<BlogPage data-id="element-22" />} data-id="element-21" />
      </Routes>
    </BrowserRouter>;
}